var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g2, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSingleDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_138_2245)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.405,
    y: 16.467,
    width: 144.453,
    height: 100.405,
    rx: 8,
    transform: "rotate(90 116.405 16.467)",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.6598,
    y: 35.2522,
    width: 77.7328,
    height: 8.42105,
    rx: 4.21053,
    fill: "#EAEAEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6598,
    y: 75.4143,
    width: 77.7328,
    height: 8.42105,
    rx: 4.21053,
    fill: "#EAEAEA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6598,
    y: 55.3335,
    width: 77.7328,
    height: 8.42105,
    rx: 4.21053,
    fill: "#EAEAEA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6598,
    y: 95.4956,
    width: 77.7328,
    height: 8.42105,
    rx: 4.21053,
    fill: "#EAEAEA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6598,
    y: 115.576,
    width: 77.7328,
    height: 8.42105,
    rx: 4.21053,
    fill: "#EAEAEA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6598,
    y: 135.657,
    width: 77.7328,
    height: 8.42105,
    rx: 4.21053,
    fill: "#EAEAEA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_138_2245)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 43.6737,
    width: 144.453,
    height: 100.405,
    rx: 8,
    transform: "rotate(90 176 43.6737)",
    fill: "white"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 87.255,
    y: 62.4595,
    width: 77.7328,
    height: 8.42105,
    rx: 4.21053,
    fill: "#EAEAEA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 87.255,
    y: 102.621,
    width: 77.7328,
    height: 8.42105,
    rx: 4.21053,
    fill: "#EAEAEA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 87.255,
    y: 82.5403,
    width: 77.7328,
    height: 8.42105,
    rx: 4.21053,
    fill: "#EAEAEA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 87.255,
    y: 122.702,
    width: 77.7328,
    height: 8.42105,
    rx: 4.21053,
    fill: "#EAEAEA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 87.255,
    y: 142.783,
    width: 77.7328,
    height: 8.42105,
    rx: 4.21053,
    fill: "#EAEAEA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 87.255,
    y: 162.864,
    width: 77.7328,
    height: 8.42105,
    rx: 4.21053,
    fill: "#EAEAEA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_138_2245",
    x: 0.0000915527,
    y: 0.467041,
    width: 132.405,
    height: 176.453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_2245"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_2245",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_138_2245",
    x: 59.595,
    y: 27.6737,
    width: 132.405,
    height: 176.453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_2245"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_2245",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleDoc);
export default __webpack_public_path__ + "static/media/single-doc.b06b4a9d0f6c11b27fb70718b44e16db.svg";
export { ForwardRef as ReactComponent };